import React, { useState, useEffect } from 'react'
import { axiosOpen } from '../../../api/axios';
import { Button, Container, Form, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
const ListUser = () => {
  const [role, setRole] = useState(null);
  const [userList, setUserList] = useState(null);
  const [loader, setLoader] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [openUpdate, setOpenUpdate] = useState (false);
  
  const [userFname, setUserFname] = useState (null);
  const [userLname, setUserLname] = useState (null);
  const [userBranch, setUserBranch] = useState (null);
  const [userEmail, setUserEmail] = useState (null);
  const [userUpdatePassword, setUserUpdatePassword] = useState (null);
  const [userUpStatus, setUserUpStatus] = useState (null);
  const [userId, setUserId] = useState (null);

  let userRole = '';

  const fetchUserDetails = async () => {
    const body = {
      companyId : localStorage.getItem("compId")
    }
    const response = await axiosOpen.post("/api/user/getAllUsers",body);
    setUserList(response?.data?.user);
    setDataLoader(false);

  };
  const fetchUserRole = async () => {
    const body = {
      userId : localStorage.getItem("userID")
    }
    const response = await axiosOpen.post("/api/user/getSingleUser",body);
    userRole = response?.data?.user?.role;
    setPageLoader(response?.data?.user?.role);
    console.log(response?.data?.user?.role);  
    console.log(pageLoader);  
    setDataLoader(false);
  };

  const handleStatusToggle = async (user) => {
    setDataLoader(true);
    const updatedStatus = {
      fname: user.fname,
      lname: user.lname,
      branch: user.branch,
      email: user.email,
      password: userUpdatePassword,
      status: user.status === "active" ? "inactive" : "active",
      role: "user"
    };
    console.log("UpdatedID",userId);
    //console.log("UpdatedStatus",updatedStatus);
    await axiosOpen.patch(`api/user/updateuser/${user._id}`, updatedStatus);
    fetchUserDetails();
  };

  const updateUserInfo = (userID, userStatus, userFname, userLname, userBranch, userEmail, userUpdatePassword) => {
    setUserFname(userFname);
    setUserLname(userLname);
    setUserBranch(userBranch);
    setUserEmail(userEmail);
    setUserUpdatePassword(userUpdatePassword);
    setUserId(userID);
    setUserUpStatus(userStatus);
    setOpenUpdate(true);
  };


  const updateHandleUpdate = async (e) => {
    e.preventDefault();
    const updatedData = {
      fname: userFname,
      lname: userLname,
      branch: userBranch,
      email: userEmail,
      password: userUpdatePassword,
      status: userUpStatus,
      role: "user"
    };
    console.log("UpdatedID",userId);
    console.log("updatedData",updatedData);
    const response = await axiosOpen.patch(`/api/user/updateuser/${userId}`, updatedData);
    console.log(response);
    setOpenUpdate(false);
    fetchUserDetails();
  }



  useEffect(() => {
    // Call API 1
    async function fetchUsers() {
    const body = {
      companyId : localStorage.getItem("compId")
    }
    await axiosOpen.post("/api/user/getAllUsers",body)
      .then((response) => {
        
        setUserList(response.data.user);    
      })
      .catch((error) => {
        console.log(error)
        });
      }fetchUsers();
    // Call API 2
    async function fetchUserRole() {
    const userid = {
      userId : localStorage.getItem('userID')
      }
      axiosOpen.post('api/user/getSingleUser',userid)
      .then((response) => {
        setRole(response?.data?.user?.role)
        setLoader(false);    
      })
      .catch((error) => {
        console.log(error)
        });
      }fetchUserRole();
  }, [loader]);

  return (
    <>
      { loader || (role == null || userList == null) ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>



      ) : (
        <Container className="flex-grow-1">
        <div className="d-flex align-items-center justify-content-between">
          <div className="col-8">
            <h2 className="py-3">User Listing</h2>
          </div>
          {role == 'admin'  || role == 'superadmin' ? (

<div style={{ width: "100px" }} className="col-1">
<Link to="/users/add" replace className="btn btn-primary">
  Add User
</Link>
</div>
          ) : (null)}
        
        </div>
        {userList?.length > 0 && (role == 'admin'  || role == 'superadmin') ? (
          <div className="user-table">
              <Table striped hover responsive>
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    {/* <th>Branch</th> */}
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {dataLoader ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    userList.map((item, index) => (
                     
                      <tr key={index}>
                        {item.role == 'admin' ? (

<td className="text-center">
  Admin
  </td>
                        ) : (
                        <td className="text-center">
                          <Form.Check
                            type="switch"
                            id={index}
                            defaultChecked={Boolean(item.status === "active")}
                            onClick={() => handleStatusToggle(item)}
                          />
                        </td>
                        )}
                        <td>{item.fname}</td>
                        <td>{item.lname}</td>
                        <td>{item.email}</td>
                        <td>{item.username}</td>
                        {/* <td>{item.branch}</td> */}
                        <td className="text-center">
                          <OverlayTrigger
                            key={item._id}
                            placement="bottom"
                            overlay={<Tooltip id={`tooltip-${item._id}`}>Edit User</Tooltip>}
                          >
                            <span onClick={() => updateUserInfo(item._id, item.status, item.fname, item.lname, item.branch, item.email)}><i className="bi bi-pencil-square"></i></span>
                            
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>





        ) : (
          <div className="user-table">
              <Table striped hover responsive>
                <thead>
                  <tr>
                    {/* <th>Status</th> */}
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    {/* <th>Branch</th> */}
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {dataLoader ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    userList.map((item, index) => (
                       
                      <tr key={index}>
                        
                        {/* <td className="text-center">
                          <Form.Check
                            type="switch"
                            id={index}
                            defaultChecked={Boolean(item.status === "active")}
                            onClick={() => handleStatusToggle(item)}
                          />
                        </td> */}
                        
                        <td>{item.fname}</td>
                        <td>{item.lname}</td>
                        <td>{item.email}</td>
                        <td>{item.username}</td>
                        {/* <td>{item.branch}</td> */}
                        {item.role == 'admin' ? (

<td className="text-center">
  Admin
  </td>
                        ) : (
             <>
             {item._id == localStorage.getItem("userID") ? (
             
             
             <td className="text-center">
             <OverlayTrigger
             key={item._id}
             placement="bottom"
             overlay={<Tooltip id={`tooltip-${item._id}`}>Edit User</Tooltip>}
           >
            
             <span onClick={() => updateUserInfo(item._id, item.status, item.fname, item.lname, item.branch, item.email)}><i className="bi bi-pencil-square"></i></span>

           
             
             
           </OverlayTrigger>
         </td>
             ) : (
              <>
        <td className="text-center">
 User
  </td>
          </>
             )}
            
         
           </>
                        )}
           
                        
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
        )}





<Modal show={openUpdate}>
          <Modal.Header>
              <Modal.Title>Update Profile</Modal.Title>
              <span className="text-left" onClick={() => setOpenUpdate(false)}>X</span>
          </Modal.Header>
          <Modal.Body>
            <Form className="update-user-info">
              <Form.Group className="mb-3">
                <Form.Label>First Name:</Form.Label>
                <Form.Control value = {userFname}
                  onChange={(e) => {
                    setUserFname(e.target.value);
                  }}
                />
                <Form.Label>Last Name:</Form.Label>
                <Form.Control value = {userLname}
                  onChange={(e) => {
                    setUserLname(e.target.value);
                  }}
                />
                <Form.Label>Email:</Form.Label>
                <Form.Control value = {userEmail}
                  onChange={(e) => {
                    setUserEmail(e.target.value);
                  }}
                  readOnly 
                />
                <Form.Label>Update Password:</Form.Label>
                <Form.Control value = {userUpdatePassword}
                  onChange={(e) => {
                    setUserUpdatePassword(e.target.value);
                  }}
                />
                <div style={{display:"none"}}>
                <Form.Label >Branch Name:</Form.Label>
                <Form.Control value = {userBranch}
                  onChange={(e) => {
                    setUserBranch(e.target.value);
                  }}
                />
                </div>
              </Form.Group>
              
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={updateHandleUpdate}>
                Update
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>

      )}
    </>
    
  )
}

export default ListUser